export enum SeveridadeToast {
    Success = 'success',
    Error = 'error',
    Warn = 'warn',
    Info = 'info'
  }